export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10208.f9cd97f2.jpg";